import React, { useState } from 'react'
import styled from 'styled-components'
import CallIcon from '@material-ui/icons/Call';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import footer from '../Background/footer2.jpg';
import {db} from './firebase.js';
import emailjs from 'emailjs-com'
function Footer() {

    const[name,setName]=useState("");
    const[email,setEmail]=useState("");
    const[subject,setSubject]=useState("");
    const[message,setMessage]=useState("");

    const handleSubmit=(e)=>{
    
      e.preventDefault();
      emailjs.sendForm('service_kujvn0j','template_cbbhe6m',e.target,'user_MOpjuE6LrnflE2BrHlC23')
        .then((result)=>{
            console.log(result.text);
        },(error)=>{
            console.log(error.text);
        });
       
    
    
    
    
    
    db.collection('contacts').add({
        name:name,
        email:email,
        subject:subject,
        message:message,
        
    })
    .then(()=>{
        alert("message has been sent");
    })
    .catch((err)=>{
        alert(err.message);
    })
    setName('');
    setEmail('');
    setSubject('');
    setMessage('');
    }
    return (
        <Wrapper id="contact" className="wrap">
            <FooterWrapper>
            <Heading>
                <h2>Contact</h2>
                <h1>
                Say Hello
                </h1>
                <p>Fill out the form so that we can connect!</p>
                <hr/>
            </Heading>
              <Contact>

                <Form>
                    <form onSubmit={handleSubmit}>
                        <input autoComplete="none" autoFocus={false} type="text"  name="name" placeholder="Name" value={name} onChange={(e)=>setName(e.target.value)} required/>
                        <input autoComplete="none" type="email" name="email" placeholder="Email" value={email} onChange={(e)=>setEmail(e.target.value)} required/>
                        <input autoComplete="none" type="text" name="subject" placeholder="Subject" value={subject} onChange={(e)=>setSubject(e.target.value)}/>
                        <textarea placeholder="MESSAGE" name="message" value={message} onChange={(e)=>setMessage(e.target.value)} required></textarea>
                    <button type="submit">Submit</button>
                    </form>
                    
                </Form>

                <PersonalDetails>

                    <Phone>
                    <h3>Phone number</h3>
                    <p><CallIcon/> +91-8802000111</p>
                    </Phone>

                    <Email>
                        <h3>Email</h3>
                        <p><MailOutlineIcon/> shashwat742@gmail.com</p>
                    </Email>
                    <Address>
                        <h3><LocationOnIcon/> Delhi,India</h3>
                       
                    </Address>
                </PersonalDetails>
              </Contact>

            </FooterWrapper>

        </Wrapper>
    )
}

export default Footer
const Wrapper=styled.div`
color:white;
background-image:url(${footer});
background-size:cover;
background-position:center;
`;

const FooterWrapper=styled.div`
padding-top:10%;
background-image:linear-gradient(
    to top,
    rgba(0, 0, 0, 0.8) 0,
    rgba(0, 0, 0, 0) 60%,
    rgba(0, 0, 0, 0.8) 100%
  );
`;
const Heading=styled.div`
text-align:center;
h1{
    font-size:40px;
    letter-spacing:5px;
    word-spacing:2px;

}
h2{
    font-size:24px;
    letter-spacing:2px;
}
p{
    word-spacing:2px;
    letter-spacing:2px;
}
hr{
    width:15%;
    border:0.5px solid lightgrey;
}
@media screen and (max-width:768px){
    h1{
        font-size:30px;

    }
    h2{
        font-size:20px;

    }
    p{
        font-size:14px;
    }
}
`;

const Contact=styled.div`
margin:0 10%;
padding-bottom:5%;
display:grid;
grid-template-columns:60% 50%;

@media screen and (max-width:768px){
    display:flex;
    flex-direction:column;
}
`;


const Form=styled.div`
form{
    display:flex;
    flex-direction:column;
    
}
input{
    letter-spacing:2px;
    font-family:inherit;
    color:whitesmoke;
    padding-top:1.5rem;
    background:transparent;
    border:none;
    border-bottom:2px solid whitesmoke;
}
input::placeholder{
    color:whitesmoke;
    letter-spacing: 2px;
}
input:focus{
    outline:none;
}
input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
textarea{
    resize:none;
    font-family:inherit;
    letter-spacing:2px;
    color:whitesmoke;
    border:none;
    background:transparent;
    border-bottom:2px solid whitesmoke;
    padding-top:2%;
    padding-bottom:10%;
    
}
textarea::-webkit-scrollbar {
    display: none;
}
textarea::placeholder{
    color:whitesmoke;
    letter-spacing: 2px;

}
textarea:focus{
    outline:none;
}

button{
    font-weight:bold;
    margin-top:5%;
    background:whitesmoke;
    border:none;
    border-radius:4px;
    height:3em;
    width:40%;
}
button:hover{
    cursor:pointer;
}
@media screen and (max-width:768px){
    transform:translate(-7%,-5%);
    button{
        height:30px;
        
    }
}

`;
const PersonalDetails=styled.div`
padding-left:30%;
display:grid;
letter-spacing:2px;

@media screen and (max-width:768px){
    transform:translate(-35%,10%);
    display:grid;
    font-size:12px;
}
`;
const Phone=styled.div``;
const Email=styled.div``;
const Address=styled.div``;
